export default {
  ControlDirection: 'Control Direction',
  InDirection: 'Inbound Direction',
  OutDirection: 'Outbound Direction',
  ControlType: 'Control Type',
  Allow: 'Allow',
  Reject: 'Reject',
  AccessControlRelatedNet: 'Access control rules-associated gateway',
  ContinueRelate: 'Continue to associate',
  GatewayMoreThan100: (gatewayNames: string) => `Gateway ${gatewayNames} has over 100 associated rules, continue to associate will exclude the above gateway from further submisison.`,
  AllGatewayMoreThan: (gatewayNames: string) => `Gateway ${gatewayNames} has over 100 associated rules, please reselect the gateway.`,
}